module.exports = {
  "messages": {
    "ARMSTRONG_BIG_SCREEN_ERROR_DESCRIPTION": "Du hast versucht, auf eine XING Seite zu kommen, die Du nur auf Deinem Smartphone sehen kannst. Also probier’s dort gleich nochmal.",
    "ARMSTRONG_BIG_SCREEN_ERROR_INSTRUCTIONS": "Du hast die XING App noch nicht? Dann lad sie Dir für Android oder iOS kostenlos herunter.",
    "ARMSTRONG_BIG_SCREEN_ERROR_TITLE": "Das hat nicht geklappt. Auf Deinem Smartphone funktioniert’s.",
    "CONTENT_ERROR_404_HEADLINE": "Es tut uns leid: Diese Seite ist leider wie vom Winde verweht.",
    "CONTENT_ERROR_404_SUBLINE": "Aber hier gibt's garantiert etwas zu entdecken:",
    "SYSM_WEB_ERROR_CTA": "Zur XING Startseite",
    "A11Y_LOGO": "Zur XING Startseite",
    "A11Y_SETTINGS_DROPDOWN_LABEL": "Einstellungen verwalten",
    "ACTIVE_LANGUAGE": "Deutsch",
    "ARMSTRONG_DISCO_NAVIGATION_ICON_TEXT": "Austausch",
    "FOOTER_LANGUAGES": "Sprache",
    "FRAME_HEADER_UPSELL_PREMIUM": "Premium werden",
    "FRAME_HEADER_UPSELL_PROJOBS": "ProJobs entdecken",
    "FRAME_NAVIGATION_DISCO": "Entdecken",
    "FRAME_NAVIGATION_FEEDBACK_AND_HELP_SUBTITLE": " Was denkst Du über die neue App?",
    "FRAME_NAVIGATION_FEEDBACK_AND_HELP_TITLE": "Dein Feedback",
    "FRAME_NAVIGATION_JOBS": "Jobs",
    "FRAME_NAVIGATION_ME_HUB": "Deins",
    "FRAME_NAVIGATION_NETWORKING_ICON_TEXT": "Netzwerken",
    "FRAME_NAVIGATION_SUPI": "Start",
    "FRAME_NAVIGATION_UPSELL_HEADLINE": "Angebote für Dich",
    "HEADER_SKIP_NAVIGATION": "Navigation überspringen",
    "MALT_FOOTER_COPYRIGHT_API": "© {siteoperator} | Alle Rechte vorbehalten",
    "NOTIFICATION_CENTER_LINK": "Mitteilungen",
    "VERTICAL_NAVIGATION_BUSINESS_SOLUTIONS": "Business-Lösungen",
    "VERTICAL_NAVIGATION_BUSINESS_SOLUTIONS_SHORT": "Business",
    "VERTICAL_NAVIGATION_CAMPUS": "Campus",
    "VERTICAL_NAVIGATION_COMMUNITIES": "Gruppen",
    "VERTICAL_NAVIGATION_COMPANIES": "Unternehmen",
    "VERTICAL_NAVIGATION_CONTACTS": "Dein Netzwerk",
    "VERTICAL_NAVIGATION_CONTACTS_SHORT": "Netzwerk",
    "VERTICAL_NAVIGATION_CONTENT_PAGES": "News",
    "VERTICAL_NAVIGATION_EVENTS": "Eventmarkt",
    "VERTICAL_NAVIGATION_FEEDBACK_AND_HELP_TITLE": "Die neue XING App: Feedback & Hilfe",
    "VERTICAL_NAVIGATION_FEEDBACK_AND_HELP_TITLE_SHORT": "Neue App",
    "VERTICAL_NAVIGATION_FOOTER_ADVERTISE": "Werben auf XING",
    "VERTICAL_NAVIGATION_FOOTER_AMIANDO": "Ticketing und Eventvermarktung",
    "VERTICAL_NAVIGATION_FOOTER_ANDROID": "Android",
    "VERTICAL_NAVIGATION_FOOTER_ANSCHREIBEN": "Anschreiben-Editor",
    "VERTICAL_NAVIGATION_FOOTER_APPS": "Apps",
    "VERTICAL_NAVIGATION_FOOTER_APP_GALLERY": "Mobile & Desktop Apps",
    "VERTICAL_NAVIGATION_FOOTER_BEWERBUNG": "Bewerbungsratgeber",
    "VERTICAL_NAVIGATION_FOOTER_CAMPUS": "Campus",
    "VERTICAL_NAVIGATION_FOOTER_CAREER": "Karriere",
    "VERTICAL_NAVIGATION_FOOTER_COACHES": "Coaches + Trainer",
    "VERTICAL_NAVIGATION_FOOTER_COMMUNITY": "Community",
    "VERTICAL_NAVIGATION_FOOTER_COMPANIES": "Unternehmen",
    "VERTICAL_NAVIGATION_FOOTER_COMPANY": "Unternehmen",
    "VERTICAL_NAVIGATION_FOOTER_DEVBLOG": "Devblog",
    "VERTICAL_NAVIGATION_FOOTER_DEVELOPER_PORTAL": "Entwickler",
    "VERTICAL_NAVIGATION_FOOTER_DOWNLOAD": "Downloads",
    "VERTICAL_NAVIGATION_FOOTER_EVENTS": "Events",
    "VERTICAL_NAVIGATION_FOOTER_GEHALTSVERGLEICH": "Gehaltsvergleich",
    "VERTICAL_NAVIGATION_FOOTER_GROUPS": "Gruppen",
    "VERTICAL_NAVIGATION_FOOTER_HELP": "Hilfe & Kontakt",
    "VERTICAL_NAVIGATION_FOOTER_IMPRINT": "Impressum",
    "VERTICAL_NAVIGATION_FOOTER_INVESTOR_RELATIONS": "Investor Relations",
    "VERTICAL_NAVIGATION_FOOTER_IPHONE_IPAD": "iPhone & iPad",
    "VERTICAL_NAVIGATION_FOOTER_JOB_MARKET": "Stellenmarkt",
    "VERTICAL_NAVIGATION_FOOTER_KUNUNU": "Arbeitgeber-Bewertungen",
    "VERTICAL_NAVIGATION_FOOTER_LEBENSLAUF": "Lebenslauf-Editor",
    "VERTICAL_NAVIGATION_FOOTER_LOGINWXING": "Button \"Mit XING einloggen\"",
    "VERTICAL_NAVIGATION_FOOTER_MEMBERSHIPS": "Mitgliedschaften",
    "VERTICAL_NAVIGATION_FOOTER_MOBILE": "XING Apps",
    "VERTICAL_NAVIGATION_FOOTER_NEWWORKSE": "New Work SE",
    "VERTICAL_NAVIGATION_FOOTER_PEOPLE_DIRECTORY": "Mitgliederverzeichnis",
    "VERTICAL_NAVIGATION_FOOTER_PREMIUM_MEMBERSHIP": "Premium",
    "VERTICAL_NAVIGATION_FOOTER_PRESS": "Presse",
    "VERTICAL_NAVIGATION_FOOTER_PRIVACY": "Datenschutz bei XING",
    "VERTICAL_NAVIGATION_FOOTER_PRIVACY_POLICY": "Datenschutzerklärung",
    "VERTICAL_NAVIGATION_FOOTER_PROJOBS_MEMBERSHIP": "ProJobs",
    "VERTICAL_NAVIGATION_FOOTER_PRO_BUSINESS_MEMBERSHIP": "ProBusiness",
    "VERTICAL_NAVIGATION_FOOTER_RESOURCES": "Ressourcen",
    "VERTICAL_NAVIGATION_FOOTER_SERVICES": "Weitere Angebote",
    "VERTICAL_NAVIGATION_FOOTER_TALENT_MANAGER": "Personalgewinnung mit XING",
    "VERTICAL_NAVIGATION_FOOTER_TANDC": "AGB",
    "VERTICAL_NAVIGATION_FOOTER_TRACKING": "Tracking",
    "VERTICAL_NAVIGATION_FOOTER_WINDOWS_10": "Windows 10",
    "VERTICAL_NAVIGATION_FOOTER_XAS": "Werbeanzeige erstellen",
    "VERTICAL_NAVIGATION_FOOTER_XING_AG": "New Work SE",
    "VERTICAL_NAVIGATION_FOOTER_XING_NEWS": "XING News",
    "VERTICAL_NAVIGATION_FOOTER_XING_SHARE": "Button \"Auf XING teilen\"",
    "VERTICAL_NAVIGATION_FOOTER_YOUR_XING": "Hauptbereiche",
    "VERTICAL_NAVIGATION_HEADER_BRAND_MANAGER_EDITOR": "Unternehmensprofile verwalten",
    "VERTICAL_NAVIGATION_HEADER_HELP": "Hilfe",
    "VERTICAL_NAVIGATION_HEADER_MANAGE_JOBS": "Stellenanzeigen verwalten",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_ADS": "Werbeanzeigen verwalten",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_COACH_PROFILE": "Mein Coach- / Trainer-Profil",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_INVOICES": "Rechnungen & Konten",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_LOGOUT": "Ausloggen",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_PREMIUM_MEMBERSHIP": "Premium",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_PROBUSINESS_MEMBERSHIP": "ProBusiness",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_PROJOBS_MEMBERSHIP": "ProJobs",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_PROJOBS_SETTINGS": "ProJobs-Einstellungen",
    "VERTICAL_NAVIGATION_HEADER_PERSONAL_SETTINGS": "Einstellungen",
    "VERTICAL_NAVIGATION_HEADER_SEAT_MANAGER_ADMIN": "LizenzManager",
    "VERTICAL_NAVIGATION_HEADER_XTM": "TalentManager",
    "VERTICAL_NAVIGATION_MESSAGES": "Nachrichten",
    "VERTICAL_NAVIGATION_MORE": "Mehr",
    "VERTICAL_NAVIGATION_MYPROJOBS": "ProJobs",
    "VERTICAL_NAVIGATION_OTHER_SERVICES": "Weitere Services",
    "VERTICAL_NAVIGATION_PREMIUM_BENEFITS": "Premium",
    "VERTICAL_NAVIGATION_PREMIUM_BENEFITS_FOR_BASIC_USER": "Premium werden",
    "VERTICAL_NAVIGATION_PREMIUM_BENEFITS_SHORT": "Premium",
    "VERTICAL_NAVIGATION_PROBUSINESS": "ProBusiness",
    "VERTICAL_NAVIGATION_PROJOBS_UPSELL": "ProJobs entdecken",
    "VERTICAL_NAVIGATION_PROJOBS_UPSELL_SHORT": "ProJobs",
    "VERTICAL_NAVIGATION_STARTPAGE": "Startseite",
    "X_UI_HEADER_REGISTER": "Registrieren",
    "X_UI_NAVIGATION_LOGIN_FRAME_FALLBACK": "Einloggen",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_COMPANIES": "Ein Unternehmen",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_EVENTS": "Ein Event",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_GROUPS": "Eine Gruppe",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_JOBS": "Einen Job",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_MEMBERS": "Eine Person",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_NEWS": "Einen Artikel",
    "DS_PREDICTIVE_SEARCH_NAVIGATION_SUGGESTIONS_TOPICS": "Ein Thema",
    "DS_PREDICTIVE_SEARCH_QUERY_SUGGESTIONS_JOBS": "Entdecke {keyword}-Jobs.",
    "DS_PREDICTIVE_SEARCH_QUERY_SUGGESTIONS_JOBS_SHORT": "{keyword}-Jobs entdecken",
    "JOB_SEARCH_ALERTS_ALERT_NAME_ALL": "Alle Jobs",
    "SE_JOBS_SUGGESTED_NAME_LOCATION": "Jobs in {location}",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_ALL_RESULTS": "Alle Ergebnisse",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_BUTTON": "Suchen",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_COMMUNITIES": "Gruppen",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_COMPANIES_PROFILE": "Arbeitgeber",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_EVENTS": "Events",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_JOBS": "Jobs",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_MEMBERS": "Mitglieder",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_NEWS": "Branchen-News",
    "VERTICAL_NAVIGATION_HEADER_SEARCH_PLACEHOLDER": "Namen / Stichwort eingeben",
    "VERTICAL_NAVIGATION_FOOTER_HALLO_FREELANCER": "Freelancer verwalten",
    "VERTICAL_NAVIGATION_FOOTER_NEW_WORK_EXPERIENCE": "NWX – Neues zur Zukunft der Arbeit"
  }
}